<section
  class="limit"
  [formGroup]="childForm"
  *ngIf="currentDataFields && currentDataFields.length"
>
  <span
    class="heading"
    *ngIf="currentDataFields && currentDataFields.length > 0"
  >
    <ng-container *ngIf="chartType == 'Table'">TOP NUMBER OF ROWS</ng-container>
    <ng-container *ngIf="chartType != 'Table'"
      >TOP NUMBER OF GROUPS</ng-container
    >
  </span>

  <div class="fieldArea" [formGroup]="childForm">
    <div class="group-list">
      <div>
        <div class="reportField-box">
          <div class="reportFields">
            <div class="right">
              <mat-form-field style="width: 100%" appearance="fill">
                <input
                  matInput
                  type="number"
                  name="limit"
                  id="limit"
                  placeholder="Enter a limit for this chart data"
                  aria-label="Enter a limit for this chart data"
                  formControlName="dataLimit"
                  (change)="buildAggregateData($event)"
                />
                <mat-error *ngIf="childForm.get('dataLimit').hasError('min')"
                  >Value must be greater than 0</mat-error
                >
              </mat-form-field>
            </div>
            <div class="far-right"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
